export type IPurchaseCostCenter = {
  [x: string]: unknown;
  _id: string;
  costCenterId: string;
  description: string;
  createdAt: Date;
  categoriesId: string[];
}

export const emptyPurchaseCostCenter = () => ({
  _id: "",
  costCenterId: "",
  description: "",
  createdAt: new Date(),
  categoriesId: []
}) as IPurchaseCostCenter;